<div class="sm-register-page" *ngIf="!isLoading && !invalidLink && agency">

  <!-- ============ TOP AGENCY INFO BAR (full width) ============ -->
  <div class="sm-agency-bar">
    <div class="sm-agency-left">
      <div class="sm-agency-logo">
        <img *ngIf="agency.AgencyLogoUrl && !logoFailed" [src]="agency.AgencyLogoUrl" alt="{{ agency.FirmName }}" (error)="logoFailed = true" />
        <div *ngIf="!agency.AgencyLogoUrl || logoFailed" class="sm-logo-fallback">
          {{ (agency.FirmName || 'A').charAt(0) }}
        </div>
      </div>
      <div class="sm-agency-name">
        <h4 class="mb-0">
          {{ agency.FirmName }}
          <span class="material-symbols-outlined verified-badge" *ngIf="agency.FirmName">verified</span>
        </h4>
        <div class="sm-agency-sub" *ngIf="agency.FirmID_Display">{{ agency.FirmID_Display }}</div>
        <div class="sm-agency-sub" *ngIf="agency.RegistrationType">{{ agency.RegistrationType }}</div>
      </div>
    </div>

    <div class="sm-agency-mid">
      <div class="sm-comm-title" *ngIf="agency.StateLicensed">
        Other details : States Licensed For Business : {{ agency.StateLicensed }}
      </div>
      <div class="sm-comm-label">Communication Details</div>
      <div class="sm-comm-row">
        <span class="sm-comm-item" *ngIf="agency.Address || agency.City || agency.State">
          <span class="material-symbols-outlined">location_on</span>
          <span>
            <span class="sm-comm-key">Location</span><br />
            {{ agency.Address }}{{ agency.City ? ', ' + agency.City : '' }}{{ agency.State ? ', ' + agency.State : '' }}{{ agency.ZipCode ? ' ' + agency.ZipCode : '' }}
          </span>
        </span>
        <span class="sm-comm-item" *ngIf="agency.Phone">
          <span class="material-symbols-outlined">call</span>
          <span>
            <span class="sm-comm-key">Phone</span><br />
            {{ agency.Phone }}
          </span>
        </span>
        <span class="sm-comm-item" *ngIf="agency.Email">
          <span class="material-symbols-outlined">mail</span>
          <span>
            <span class="sm-comm-key">Email</span><br />
            {{ agency.Email }}
          </span>
        </span>
      </div>
    </div>

    <div class="sm-agency-right">
      <div class="sm-reg-type-box">
        <div class="sm-reg-type-label">Registration Type</div>
        <div class="sm-reg-type-value">
          <span class="material-symbols-outlined">person</span> Customer
        </div>
      </div>
    </div>
  </div>

  <!-- ============ BODY: image panel + form ============ -->
  <div class="sm-body">
    <!-- Left image panel -->
    <div class="sm-image-panel">
      <div class="sm-image-overlay">
        <h2>Welcome!</h2>
        <p>Create your account to get started and access our services.</p>
      </div>
    </div>

    <!-- Right form panel -->
    <div class="sm-form-panel">
      <div class="loginbox">
        <!-- Step 1: Sign Up -->
        <div *ngIf="currentStep === 'signup'">
          <form class="login-form" [formGroup]="signUpForm" (ngSubmit)="onSignUp()" #form="ngForm" autocomplete="off">
            <div class="mb-2 mt-2">
              <mat-label>{{ 'EMAIL'|translate }} <span class="text-danger">*</span></mat-label>
              <input matInput class="mat-mdc-input-element w-100 form-control" [placeholder]="'ENTER_EMAIL' | translate" formControlName="email" />
              <mat-error class="text-danger" *ngIf="(form.submitted || signUpForm.get('email')?.touched) && signUpForm.controls['email'].errors?.['required']">{{'EMAIL_ADDRESS_REQUIRED' | translate}}</mat-error>
              <mat-error class="text-danger" *ngIf="(form.submitted || signUpForm.get('email')?.touched) && signUpForm.controls['email'].errors?.['email']">{{'EMAIL_INVALID' | translate}}</mat-error>
            </div>
            <div class="mb-2">
              <mat-label>{{ 'FIRST_NAME'|translate }} <span class="text-danger">*</span></mat-label>
              <input matInput class="mat-mdc-input-element w-100 form-control" [placeholder]="'ENTER_FIRST_NAME' | translate" formControlName="firstName" />
              <mat-error class="text-danger" *ngIf="(form.submitted || signUpForm.get('firstName')?.touched) && signUpForm.controls['firstName'].errors?.['required']">{{'FIRST_NAME_REQUIRED' | translate}}</mat-error>
            </div>
            <div class="mb-2">
              <mat-label>{{ 'LAST_NAME'|translate }} <span class="text-danger">*</span></mat-label>
              <input matInput class="mat-mdc-input-element w-100 form-control" [placeholder]="'ENTER_LAST_NAME' | translate" formControlName="lastName" />
              <mat-error class="text-danger" *ngIf="(form.submitted || signUpForm.get('lastName')?.touched) && signUpForm.controls['lastName'].errors?.['required']">{{'LAST_NAME_REQUIRED' | translate}}</mat-error>
            </div>
            <div class="mb-2">
              <mat-label>{{ 'MOBILE_NUMBER'|translate }} <span class="text-danger">*</span></mat-label>
              <input matInput class="mat-mdc-input-element w-100 form-control" placeholder="XXX-XXX-XXXX" formControlName="mobileNumber" maxlength="12" (input)="formatMobileNumber()" />
              <mat-error class="text-danger" *ngIf="(form.submitted || signUpForm.get('mobileNumber')?.touched) && signUpForm.controls['mobileNumber'].errors?.['required']">{{'MOBILE_NUMBER_REQUIRED' | translate}}</mat-error>
              <mat-error class="text-danger" *ngIf="(form.submitted || signUpForm.get('mobileNumber')?.touched) && signUpForm.controls['mobileNumber'].errors?.['pattern']">{{'MOBILE_NUMBER_INVALID' | translate}}</mat-error>
            </div>
            <div class="mb-2">
              <mat-label>{{ 'ZIP_CODE'|translate }} <span class="text-danger">*</span></mat-label>
              <input matInput class="mat-mdc-input-element w-100 form-control" formControlName="zipCode"
                [placeholder]="'ZIP_CODE_PLACEHOLDER' | translate"
                [matAutocomplete]="autoZip"
                (keyup)="onZipCodeChange()"
                oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                maxlength="5" />
              <mat-autocomplete #autoZip="matAutocomplete" (optionSelected)="onZipCodeSelected($event.option.value)">
                <mat-option *ngFor="let zip of filteredZipCodes" [value]="zip">{{ zip }}</mat-option>
              </mat-autocomplete>
              <mat-error class="text-danger" *ngIf="(form.submitted || signUpForm.get('zipCode')?.touched) && signUpForm.controls['zipCode'].errors?.['required']">{{'ZIP_CODE_REQUIRED' | translate}}</mat-error>
              <mat-error class="text-danger" *ngIf="(form.submitted || signUpForm.get('zipCode')?.touched) && signUpForm.controls['zipCode'].errors?.['pattern']">{{'ZIP_CODE_INVALID' | translate}}</mat-error>
            </div>
            <div class="row mb-2 mt-1">
              <div class="col-6">
                <mat-label>{{ 'COUNTY'|translate }} <span class="text-danger">*</span></mat-label>
                <input matInput class="mat-mdc-input-element w-100 form-control" formControlName="county" readonly />
              </div>
              <div class="col-6">
                <mat-label>{{ 'STATE'|translate }} <span class="text-danger">*</span></mat-label>
                <input matInput class="mat-mdc-input-element w-100 form-control" formControlName="state" readonly />
              </div>
            </div>
            <button mat-flat-button color="primary" class="my-2 w-100" type="submit" [disabled]="isSignUpLoading">{{ 'CONTINUE' | translate }}</button>
          </form>
        </div>

        <!-- Step 2: OTP -->
        <div *ngIf="currentStep === 'otp'">
          <h2 class="text-center mb-2">Verify Your Email</h2>
          <p>We've sent a verification code to <strong>{{ signUpForm.value.email }}</strong></p>
          <form class="login-form" [formGroup]="otpForm" (ngSubmit)="onVerifyOtp()" #otpFormRef="ngForm" autocomplete="off">
            <div class="mb-2 mt-2">
              <mat-label>Verification Code <span class="text-danger">*</span></mat-label>
              <input matInput class="mat-mdc-input-element w-100 form-control" formControlName="otp" maxlength="6" placeholder="Enter 6-digit code" oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
              <mat-error class="text-danger" *ngIf="(otpFormRef.submitted || otpForm.get('otp')?.touched) && otpForm.get('otp')?.hasError('required')">Code is required</mat-error>
            </div>
            <button mat-flat-button color="primary" class="my-2 w-100" type="submit" [disabled]="isOtpLoading">{{ isOtpLoading ? 'Verifying...' : 'Verify & Continue' }}</button>
          </form>
          <div class="mt-3 text-center">
            <span>Didn't receive the code? </span>
            <a href="javascript:void(0)" class="link" [class.disabled]="otpResendTimer > 0" (click)="resendOtp()">
              {{ otpResendTimer > 0 ? 'Resend in ' + otpResendTimer + 's' : 'Resend Code' }}
            </a>
          </div>
        </div>

        <!-- Step 3: Success -->
        <div *ngIf="currentStep === 'success'">
          <h2 class="text-center mb-2">Submission Successful</h2>
          <p class="text-center">Thank you! Your information has been submitted successfully.</p>
          <p class="text-center">An agent from <strong>{{ agency.FirmName }}</strong> will contact you shortly regarding your insurance inquiry.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- ============ FOOTER ============ -->
  <div class="sm-footer">
    <span>&copy; {{ currentYear }} {{ agency.FirmName }}. All rights reserved.</span>
  </div>
</div>

<!-- Invalid Link -->
<div class="sm-register-page" *ngIf="!isLoading && invalidLink">
  <div class="d-flex justify-content-center align-items-center text-center" style="min-height:100vh;">
    <div>
      <h2>Invalid Registration Link</h2>
      <p>This registration link is invalid or has expired. Please contact the agency for a new link.</p>
    </div>
  </div>
</div>

<!-- Loading -->
<div class="sm-register-page" *ngIf="isLoading">
  <div class="d-flex justify-content-center align-items-center text-center" style="min-height:100vh;">
    <p>Loading registration page...</p>
  </div>
</div>
